<template>
  <div class="edit-profile-wrapper">
    <img
      src="@/Common/Icons/Lightning.png"
      alt="Lightning"
      class="lightning-image"
    />
    <div class="edit-profile-heading">
      <div class="edit-profile-title">
        <p><span class="emphasize">Edit</span>Profile</p>
      </div>
      <div class="edit-profile-text">
        <p>Manage your personal settings</p>
      </div>
    </div>
    <edit-profile-form class="edit-profile-form"></edit-profile-form>
  </div>
</template>

<script>
import EditProfileForm from "@/components/Profile/EditProfileForm";
export default {
  components: {
    EditProfileForm,
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/editProfile.scss"></style>
